import React from "react";

const ACCENT = "#1b4d2e";

// Global safety net: without this, any uncaught render error unmounts the
// entire tree and the user sees a blank white page with no way out.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary atrapó un error de render:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-6">
        <div className="max-w-md w-full rounded-2xl border border-zinc-200 bg-white shadow-sm p-8 text-center">
          <h1 className="text-lg font-semibold text-zinc-900 mb-2">
            Algo salió mal
          </h1>
          <p className="text-sm text-zinc-500 mb-6">
            Ocurrió un error inesperado. Recarga la página para continuar; tus
            datos guardados no se pierden. Si usas la traducción automática del
            navegador, desactívala para este sitio.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-lg text-sm font-semibold text-white shadow-sm transition hover:opacity-90"
            style={{ backgroundColor: ACCENT }}
          >
            Recargar página
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
